import '../firebase/firebase'
import { notification, ConfigProvider, Spin } from 'antd'
import ReactGA from 'react-ga'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ThemeProvider } from 'styled-components'
import localeAntd from 'antd/locale/es_ES'
import { useJsApiLoader } from '@react-google-maps/api'

import { theme, GlobalStyles } from '@styles'
import { Layout, LoginWithToken } from '@components'
import { GeneralProvider, UserProvider } from '@contexts'
import { config } from '@config'

import AppRoutes from './AppRoutes'

const trackingId = config.measurementId
const googleMapsApiKey = config.googleMapsApiKey ?? ''

ReactGA.initialize(trackingId!)

notification.config({
  placement: 'topRight',
  duration: 12,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
    },
  },
})

const App = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsApiKey,
    libraries: ['places'],
  })

  if (!isLoaded) {
    return <Spin spinning={!isLoaded}></Spin>
  }

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider theme={{ token: { colorPrimary: theme.primaryColor } }} locale={localeAntd}>
        <GlobalStyles />
        <QueryClientProvider client={queryClient}>
          <Layout>
            <UserProvider>
              <LoginWithToken>
                <GeneralProvider>
                  <AppRoutes />
                </GeneralProvider>
              </LoginWithToken>
            </UserProvider>
          </Layout>
        </QueryClientProvider>
      </ConfigProvider>
    </ThemeProvider>
  )
}

export { App }
